import {useCallback} from 'react';
import {usePlayerContext} from './usePlayerContext';

/**
 * Handles setting the active audio track on the player;
 *
 * @returns (trackId: string) => void | a handler for setting the active audio track
 */
export const useSetActiveAudio = (): ((trackId: string) => void) => {
  const {player} = usePlayerContext();

  const setActiveAudio = useCallback(
    (trackId: string) => {
      if (!player) return;

      player.setAudio(trackId);
    },
    [player]
  );

  return setActiveAudio;
};
